import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: "85px 24px 24px 138px",
  },
  btnRoot: {
    position: "fixed",
    right: 0,
    top: 64,
    padding: "12px 24px",
    width: "100%",
    zIndex: 12,
    background: "#fafafa",
  },
  statsList: {
    display: "flex",
    gap: "1rem",
    flexWrap: "wrap",
  },
  statItem: {
    display: "flex",
    flex: "0 0 32%",
    backgroundColor: "white",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
    padding: "1rem",
    borderRadius: "0.5rem",
    boxShadow: "0px 1px 4px 2px rgb(0 0 0 / 5%)",
    flexDirection: "column",
  },
  statContent: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    gap: "1rem",
    justifyContent: "space-between",
  },
  statName: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "0.5rem",
    "& .about": {
      display: "flex",
      flexDirection: "column",
    },
    "& svg": {
      fontSize: "2rem",
    },
    "& .title": {
      fontSize: "1.5rem",
    },
    "& .description": {
      fontSize: "0.8rem",
      color: "#848484",
    },
  },
  statValue: {
    fontSize: "3rem",
  },
}));
